module.exports = __webpack_public_path__ + "597c1166db0b51be4217fb0de321bdbd.svg";